import React, { useMemo } from 'react';
import block from 'bem-cn';
// import PT from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import usePaymentHistory from 'features/payment/model/paymentHistory/usePaymentHistory';

import Paginator from 'components/Paginator';

import PaymentHistoryFilter from './PaymentHistoryFilter';
import PaymentHistoryItem from './PaymentHistoryItem';

import './PaymentHistory.scss';
import Spinner from 'components/Spinner';

const b = block('payment-history');

const PaymentHistory = () => {
  const { locale } = useSelector(state => state.locale);
  const {
    actionProcessing,
    depositHistory: {
      deposits,
      count,
    },
  } = useSelector(state => state.payment, shallowEqual);

  const {
    onDateFromChange,
    onDateToChange,
    onIsSuccessChange,
    onIsTimeIsUpChange,
    onPageChange,
    onSubmit,
    values,
  } = usePaymentHistory();
  
  const pageCount = useMemo(() => Math.ceil(count / values.itemsOnPage), [count, values.itemsOnPage]);

  const items = useMemo(() => deposits.map(item => (
    <PaymentHistoryItem key={item.id} item={item} />
  )), [deposits])

  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} />
      <h1 className={b('title')}>{locale.paymentHistory}</h1>

      <PaymentHistoryFilter
        onDateFromChange={onDateFromChange}
        onDateToChange={onDateToChange}
        onIsSuccessChange={onIsSuccessChange}
        onIsTimeIsUpChange={onIsTimeIsUpChange}
        onSubmit={onSubmit}
        values={values}
      />

      <div className={b('content')}>
        <div className={b('items')}>
          {items}
        </div>
        <div className={b('paginator')}>
          <Paginator
            currentPage={values.page}
            count={pageCount}
            onPageClick={onPageChange}
          />
        </div>
      </div>
    </div>
  );
};

PaymentHistory.propTypes = {};

export default PaymentHistory;
